import { render, staticRenderFns } from "./FloorAssignmentCreate.vue?vue&type=template&id=1b790e8b"
import script from "./FloorAssignmentCreate.vue?vue&type=script&lang=js"
export * from "./FloorAssignmentCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports